import { translate } from '@thoughtspot/i18n';
import { useCallback, useMemo } from 'react';
import { useCheckGroupNameExistsLazyQuery, useCheckUserNameExistsLazyQuery, useSearchRolesLazyQuery, } from "../../../services/generated/graphql-types";
import { ALL_ORG_CONTEXT_ID, PRIMARY_ORG_CONTEXT_ID, } from './shared/admin-org-context';
const TAKEN_MESSAGE_KEYS = {
    user: {
        allOrgs: 'msg_code.13100.summary',
        org: 'msg_code.13098.summary',
    },
    group: {
        allOrgs: 'msg_code.13099.summary',
        org: 'msg_code.13099.summary',
    },
    role: {
        allOrgs: 'roles.name.already.exists',
        org: 'roles.name.already.exists',
    },
};
export const useNameAvailability = ({ kind, currentOrgId, excludeId, }) => {
    const [checkUserName] = useCheckUserNameExistsLazyQuery({
        fetchPolicy: 'no-cache',
    });
    const [checkGroupName] = useCheckGroupNameExistsLazyQuery({
        fetchPolicy: 'no-cache',
    });
    const [searchRoles] = useSearchRolesLazyQuery({ fetchPolicy: 'no-cache' });
    const orgIdentifiers = useMemo(() => currentOrgId !== undefined && currentOrgId > PRIMARY_ORG_CONTEXT_ID
        ? [String(currentOrgId)]
        : undefined, [currentOrgId]);
    const takenMessage = useMemo(() => {
        const keys = TAKEN_MESSAGE_KEYS[kind];
        const isAllOrgsContext = currentOrgId === undefined || currentOrgId === ALL_ORG_CONTEXT_ID;
        const key = isAllOrgsContext ? keys.allOrgs : keys.org;
        return translate(key);
    }, [kind, currentOrgId]);
    const checkName = useCallback(async (rawName) => {
        const trimmed = rawName.trim();
        if (!trimmed)
            return { status: 'available' };
        const isHit = (id) => !!id && id !== excludeId;
        const taken = () => ({
            status: 'taken',
            takenMessage,
        });
        try {
            if (kind === 'user') {
                const r = await checkUserName({
                    variables: {
                        user_identifier: trimmed,
                        org_identifiers: orgIdentifiers,
                    },
                });
                if (r.error)
                    return { status: 'error' };
                return r.data?.Users__searchUsers?.data?.some(d => isHit(d?.id))
                    ? taken()
                    : { status: 'available' };
            }
            if (kind === 'group') {
                const r = await checkGroupName({
                    variables: {
                        group_identifier: trimmed,
                        org_identifiers: orgIdentifiers,
                    },
                });
                if (r.error)
                    return { status: 'error' };
                return r.data?.Groups__searchGroups?.data?.some(d => isHit(d?.id))
                    ? taken()
                    : { status: 'available' };
            }
            const r = await searchRoles({
                variables: {
                    data: {
                        role_identifiers: [trimmed],
                        org_identifiers: orgIdentifiers,
                        record_size: 1,
                    },
                },
            });
            if (r.error)
                return { status: 'error' };
            return r.data?.searchRoles?.Data?.roles?.some(role => isHit(role?.id))
                ? taken()
                : { status: 'available' };
        }
        catch {
            return { status: 'error' };
        }
    }, [
        kind,
        orgIdentifiers,
        excludeId,
        takenMessage,
        checkUserName,
        checkGroupName,
        searchRoles,
    ]);
    return { checkName };
};
//# sourceMappingURL=use-name-availability.js.map